import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CoalMining from "@/components/site/CoalMining";
import useSmoothScroll from "@/components/motion/useSmoothScroll";
import usePageMeta from "@/hooks/usePageMeta";

export default function CoalMiningPage() {
  useSmoothScroll();
  usePageMeta({
    title: "Coal & Mining | RUDRA EMPIRE",
    description:
      "RUDRA EMPIRE's coal & mining vertical in Jharkhand — a 75% principal ownership interest, held distinctly from the group's land-acquisition operations in Karnataka.",
    canonical: "https://rudraempire.com/coal-mining",
  });
  return (
    <main className="relative bg-[#08080A] text-neutral-100">
      <Header />
      <div className="pt-24">
        <CoalMining />
      </div>
      <Footer />
    </main>
  );
}
